import { render, staticRenderFns } from "./CardSiroRoela.vue?vue&type=template&id=2d3ebb00&"
import script from "./CardSiroRoela.vue?vue&type=script&lang=js&"
export * from "./CardSiroRoela.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports